/**
 * Demoauslieferung als einzelne HTML-Datei.
 *
 * `VITE_DEMO=1` setzt ausschliesslich der Demobau (`apps/web/demo`). Im
 * Regelbetrieb fehlt die Variable, der Schalter ist aus, und jeder daran
 * haengende Zweig faellt beim Bauen als toter Code weg.
 *
 * Der Schalter traegt genau eine Bedeutung: es gibt keine Schnittstelle, die
 * speichert. Formulare bleiben befuellbar, damit der Ablauf sichtbar ist —
 * aber der Speichern-Knopf ist abgeschaltet und sagt warum, statt einen Klick
 * in eine Fehlermeldung laufen zu lassen.
 */
export const DEMO: boolean = import.meta.env['VITE_DEMO'] === '1';

/** Ein Satz, ueberall derselbe — steht an jedem abgeschalteten Schreibweg. */
export const DEMO_HINWEIS = 'Demoansicht — es wird nichts gespeichert.';

/**
 * Die Personas des Demobetriebs — Anzeigename und Kurzhinweis.
 *
 * Sie stehen hier und nicht in `entwurf/huelle.ts`, weil sie **nur** im
 * Demobau etwas bedeuten: dort bildet `demo/datenquelle.ts` jede Persona
 * auf ein Konto des Bestands ab, und der Umschalter im Konto-Menü wechselt
 * damit das **Konto**. Die Rechte kommen anschließend aus `/api/ich`, wie
 * überall sonst auch.
 *
 * ## Warum die Liste nicht mehr im Produktivcode steht
 *
 * Bis zum 27.08.2026 führte `entwurf/navigation.ts` unter dem Namen
 * `RECHTE` eine Tabelle mit fünf Personas und ihren Rechten. Sie speiste
 * die Auskunft „Die Anwendungsrolle *IAM Admin* trägt **alle Rechte**" auf
 * `/profil` und über `darf()` die Sperren im Wegweiser und in der
 * Suchpalette. Der Schlüssel dafür war ein Wert aus dem
 * **Browserspeicher** — der Benutzer bestimmte selbst, was er zu dürfen
 * schien. In einem Werkzeug für Rechtevergabe ist eine falsche Auskunft
 * über die eigenen Rechte die unangenehmste Sorte.
 *
 * Die Demo überschreibt die Liste in `demo/einrichtung.ts`: sie kennt die
 * Anwendungsrollen ihres Bestands.
 */
export const DEMO_PERSONAS: Array<[name: string, hinweis: string]> = [
  ['IAM Admin', 'alles'],
];
